import styled from 'styled-components';
import Ico96 from 'dc/Ico96';
import Wra16A from 'dc/Wra16A';
import { Typ30 } from 'dc/Typ';

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: transparent;
`;

export const Icon = styled(Ico96)`
  color: #546e7a;
`;

export const TextWrapper = styled(Wra16A)`
  max-width: 320px;
  text-align: center;
`;

export const Text = styled(Typ30)`
  color: #546e7a;
`;
